import { findCachedEntity } from '@src/store/contentEntities/contentEntities';
import { useMemo } from 'react';
import { type UseEntityLoaderProps, useEntityLoader } from './useEntityLoader';

export const useEntityByIdentifier = (props: UseEntityLoaderProps) => {
    const { entityType, entityIdentifier = '' } = props;
    const { entityId, load, loadStatus, error } = useEntityLoader({ entityType, entityIdentifier });

    const entity = useMemo(() => findCachedEntity(entityType, entityIdentifier), [entityType, entityIdentifier]);

    return {
        entity,
        entityId: entity?.id || entityId,
        load,
        loadStatus,
        error,
    };
};
